import { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { Button } from '@motorway/mw-highway-code';

import { VehicleLookupContext } from 'Context/vehicleLookup';

import { INCODE_EARLY_DOCS_SLUG, INCODE_POST_SALE_SLUG } from 'Utilities/routing';

import { IncodeFooter } from '../components/IncodeFooter';

import styles from '../IncodeSdkPage.scss';

const IS_DEV = process.env.NODE_ENV === 'development';

export const IncodeCaptureDevHelper = ({ to }: { to: string }) => {
  const { vehicleLookupState: vehicle } = useContext(VehicleLookupContext);

  const location = useLocation();

  if (!IS_DEV) {
    return null;
  }

  const isPostSaleFlow = location.pathname.includes(INCODE_POST_SALE_SLUG);
  const path = isPostSaleFlow ? INCODE_POST_SALE_SLUG : INCODE_EARLY_DOCS_SLUG;

  return (
    <IncodeFooter className={styles.devHelper}>
      <Button as={Link} label={'Bypass for testing'} to={`/${vehicle.vrm}${path}${to}`} />
    </IncodeFooter>
  );
};
